import agent_attorney from "./agent_attorney";
import agent_attorney_individs from "./agent_attorney_individs";
import employer from "./employer";
import employer_pocs from "./employer_pocs";
import foreign_labor from "./foreign_labor";
import crop from "./crop";
import agriculture from "./agriculture";
import worker_housing from "./worker_housing";
import material_terms from "./material_terms";
import foreign_worker from "./foreign_worker";
import foreign_worker_group from "./foreign_worker_group";

const ViewEntityTabularUIResolver = (formName, formData) => {
  const viewEntityTabluarUIList = {
    "agent-attorney": agent_attorney(formData),
    "agent-attorney-individs": agent_attorney_individs(formData),
    employer: employer(formData),
    "employer-pocs": employer_pocs(formData),
    "foreign-labor": foreign_labor(formData),
    crop: crop(formData),
    "worker-housing": worker_housing(formData),
    agriculture: agriculture(formData),
    "material-terms": material_terms(formData),
    "foreign-worker": foreign_worker(formData),
    "foreign-worker-group": foreign_worker_group(formData),
  };
  return viewEntityTabluarUIList[formName];
};

export default ViewEntityTabularUIResolver;
